import React from "react";
import InfoItem from "../GeneralInfo/InfoItem";
import styles from "./styles.module.css";
const PurposeShortDetails = ({ purpose, current, legalbasis }) => {
  return (
    <div className={styles["info-short-container"]}>
      {!!purpose && <InfoItem label="Purpose" value={purpose} />}
      {!!legalbasis && <InfoItem label="Legal basis" value={legalbasis} />}
      {!!current && <InfoItem label="Current Status" value={current} />}
    </div>
  );
};

export default PurposeShortDetails;
